import React, { ReactNode } from 'react';

export const CenteredContainer = ({ children }: { children: ReactNode }) => {
	return (
		<div
			style={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				height: '100%',
				flexDirection: 'column',
				justifyCenterCss: 'center',
			}}
		>
			{children}
		</div>
	);
};
